import { z } from 'zod';
export const ProjectTagIdSchema = z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);
export const ProjectTagBindingSchema = z
    .object({
    projectId: z.string().guid(),
    tagId: ProjectTagIdSchema,
    createdAt: z.string().datetime(),
})
    .strict();
export const ProjectTagListResponseSchema = z
    .object({
    items: z.array(ProjectTagBindingSchema),
})
    .strict();
export const ProjectIdsByTagsRequestSchema = z
    .object({
    tagIds: z.array(ProjectTagIdSchema).min(1).max(20),
    match: z.literal('all').prefault('all'),
})
    .strict();
export const ProjectIdsByTagsResponseSchema = z
    .object({
    projectIds: z.array(z.string().guid()),
})
    .strict();
//# sourceMappingURL=ProjectTags.js.map